import React, { useEffect, useState } from 'react'

import { Button, Col, Divider, Form, Image, Modal, Row, Upload } from 'antd'
import { uploadAvatar } from '../../api/amazonS3'
import avatar_svg from '../../asset/icons/profile-user-svgrepo-com.svg'
import { UploadOutlined } from '@ant-design/icons'

const ProfilePhotoEditForm = ({ toLoad, visible, email, onSubmit, onCancel }) => {
  //destructures props
  const [profilePhoto, setProfilePhoto] = useState(null)

  useEffect(() => {
    if (toLoad && visible) {
      setProfilePhoto(toLoad.src)
    }
  }, [toLoad, visible])

  const customAvatarRequest = (options) => {
    //this occurs on upload, not submit
    const { onError, onSuccess, file, onProgress } = options
    uploadAvatar(email, file, onSuccess, onError, onProgress)
  }

  const getAvatarValueFromEventHandler = (e) => {
    if (e.file.response !== undefined) {
      setProfilePhoto(e.file.response.url)
    }
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  return (
    <Modal
      visible={visible}
      title='Edit Profile Photo'
      okText='OK'
      onCancel={onCancel}
      width={'66vw'}
      style={{ top: 20 }}
      onOk={() => {
        onSubmit(profilePhoto)
      }}
    >
      <div
        style={{
          width: '100%',
          height: '66vh',
          paddingTop: 6,
          paddingBottom: 6,
          paddingRight: 24,
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <p>
          <i>
            Use a profile photo to help audiences find you.{' '}
            <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faq/docs/doc-showcase/'}>
              Learn More
            </a>
            .
          </i>
        </p>
        <Divider />
        <h5>Profile Photo:</h5>
        <Row style={{ marginLeft: 12 }}>
          {!profilePhoto && (
            <Col>
              <Image style={{ width: 128, marginRight: 32 }} preview={false} src={avatar_svg} />
            </Col>
          )}

          {profilePhoto && (
            <Col>
              <Image
                style={{
                  width: toLoad.width,
                  height: toLoad.height,
                  marginRight: 32
                }}
                preview={false}
                src={profilePhoto}
              />
            </Col>
          )}
          <Form.Item style={{ marginRight: 32 }} name='avatar' valuePropName='fileList' getValueFromEvent={getAvatarValueFromEventHandler}>
            <Upload
              style={{ marginRight: 32 }}
              accept='image/*'
              listType='picture-card'
              customRequest={customAvatarRequest}
              maxCount={1}
              className='upload-list-inline'
              onChange={({ file }) => {
                if (file.status === 'remove') {
                  setProfilePhoto(null)
                } else if (file.status === 'done') {
                  setProfilePhoto(file.response.url)
                }
              }}
            >
              <Button icon={<UploadOutlined />} />
            </Upload>
          </Form.Item>
        </Row>
      </div>
    </Modal>
  )
}

export default ProfilePhotoEditForm
